import React from "react"
import { isEmpty } from "lodash-es"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { departmentMembershipFacilitiesShape } from "utils/propTypeShapes"
import DepartmentMembershipFacility from "./DepartmentMembershipFacility"

const DepartmentMembershipFacilities = ({ departmentMembershipFacilities }) => {
  const { pluralNameInSentence: departmentsNameInSentence } = useCustomName(DEPARTMENT_KEY)

  if (isEmpty(departmentMembershipFacilities)) {
    return (
      <span className="font-light">
        This user is not a member of any {departmentsNameInSentence}.
      </span>
    )
  }

  return (
    <>
      {
        departmentMembershipFacilities.map((facility) => (
          <DepartmentMembershipFacility
            key={facility.id}
            departmentMembershipFacility={facility}
          />
        ))
      }
    </>
  )
}

DepartmentMembershipFacilities.propTypes = {
  departmentMembershipFacilities: departmentMembershipFacilitiesShape.isRequired,
}

export default DepartmentMembershipFacilities
